import type { InferOutput } from "valibot"
import { boolean, number, object, string } from "valibot"

export const CategorySchema = object({
  id: string(),
  title: string(),
  active: boolean(),
  results: number(),
})

export type Category = InferOutput<typeof CategorySchema>
